module.exports = require("./ar-ER.d.ts");